import { render, staticRenderFns } from "./Dispositivos.vue?vue&type=template&id=367a978e&"
import script from "./Dispositivos.vue?vue&type=script&lang=js&"
export * from "./Dispositivos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports